import React, { useEffect } from 'react';
import { LogoLoadingIndicator } from '@/components/logo-loading-indicator';
import { PricingCustomerDetailScreen } from '@/experiences/sales-portal/domain/pricing/screens/customers/pricing-customer-detail-screen';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack';
import { useBusinessOrganizationPricingConfig } from '@/experiences/sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useNavigation } from '@react-navigation/native';
import { validate } from 'uuid';

type Props = StackScreenProps<
  SalesPortalStackParams,
  typeof SALES_PORTAL_ROUTES.PricingCustomerDetail
>;

export const PricingCustomerDetailScreenWrapper: React.FC<Props> = (props) => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();
  const { restaurantUUID } = props.route.params;
  const isRestaurantUUIDValid = validate(restaurantUUID);

  const { loading, error, hasPricingAccess, hasCustomerTableAccess } =
    useBusinessOrganizationPricingConfig();

  useEffect(() => {
    const accessDenied =
      !loading && !error && (!hasPricingAccess || !hasCustomerTableAccess);
    if (!isRestaurantUUIDValid || accessDenied) {
      navigation.replace(SALES_PORTAL_ROUTES.NotFound);
    }
  }, [
    error,
    hasCustomerTableAccess,
    hasPricingAccess,
    isRestaurantUUIDValid,
    loading,
    navigation,
  ]);

  if (!isRestaurantUUIDValid) {
    return null;
  }

  return loading ? (
    <LogoLoadingIndicator />
  ) : (
    <PricingCustomerDetailScreen {...props} />
  );
};
